/**
 * Skeleton loader para las tarjetas de tareas cron
 * Muestra un placeholder mientras carga
 */
import React from 'react'

const CronTaskSkeleton: React.FC = React.memo(() => {
  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6 animate-pulse">
      {/* Header skeleton */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
          <div className="h-6 bg-gray-200 rounded w-48"></div>
        </div>
        <div className="h-6 bg-gray-200 rounded w-20"></div>
      </div>

      {/* Description skeleton */}
      <div className="mb-4 space-y-2">
        <div className="h-4 bg-gray-200 rounded w-full"></div>
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
      </div>

      {/* Info skeleton */}
      <div className="space-y-3 mb-4">
        <div className="h-4 bg-gray-200 rounded w-32"></div>
        <div className="h-4 bg-gray-200 rounded w-40"></div>
        <div className="h-4 bg-gray-200 rounded w-36"></div>
      </div>

      {/* Button skeleton */}
      <div className="h-10 bg-gray-200 rounded w-full"></div>
    </div>
  )
})

CronTaskSkeleton.displayName = 'CronTaskSkeleton'

export default CronTaskSkeleton

